<template>
    <div class="top-bar flex items-center !flex-shrink-0">
        <div class="flex items-center h-full gap-4 top-bar-menu">
            <div class="cursor-pointer">Home</div>
            <a-dropdown class="text-[#3F4249]">
                <a class="ant-dropdown-link" @click.prevent>
                    订单管理
                    <DownOutlined />
                </a>
                <template #overlay>
                    <a-menu>
                        <a-menu-item>
                            <a href="javascript:;">1st menu item</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a href="javascript:;">2nd menu item</a>
                        </a-menu-item>
                    </a-menu>
                </template>
            </a-dropdown>
            <a-dropdown class="text-[#3F4249]">
                <a class="ant-dropdown-link" @click.prevent>
                    商品管理
                    <DownOutlined />
                </a>
                <template #overlay>
                    <a-menu>
                        <a-menu-item>
                            <a href="javascript:;">1st menu item</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a href="javascript:;">2nd menu item</a>
                        </a-menu-item>
                    </a-menu>
                </template>
            </a-dropdown>
            <a-dropdown class="text-[#3F4249]">
                <a class="ant-dropdown-link" @click.prevent>
                    CS管理
                    <DownOutlined />
                </a>
                <template #overlay>
                    <a-menu>
                        <a-menu-item>
                            <a href="javascript:;">1st menu item</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a href="javascript:;">2nd menu item</a>
                        </a-menu-item>
                    </a-menu>
                </template>
            </a-dropdown>
            <a-dropdown class="text-[#3F4249]">
                <a class="ant-dropdown-link" @click.prevent>
                    客户支援
                    <DownOutlined />
                </a>
                <template #overlay>
                    <a-menu>
                        <a-menu-item>
                            <a href="javascript:;">1st menu item</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a href="javascript:;">2nd menu item</a>
                        </a-menu-item>
                    </a-menu>
                </template>
            </a-dropdown>
            <a-dropdown class="text-[#3F4249]">
                <a class="ant-dropdown-link" @click.prevent>
                    表格
                    <DownOutlined />
                </a>
                <template #overlay>
                    <a-menu>
                        <a-menu-item>
                            <a href="javascript:;">1st menu item</a>
                        </a-menu-item>
                        <a-menu-item>
                            <a href="javascript:;">2nd menu item</a>
                        </a-menu-item>
                    </a-menu>
                </template>
            </a-dropdown>
            <span
                class="bg-[#F1F3F8] text-[#3F4249] right-action-btn inline-block flex items-center justify-center gap-1">
                <img src="@/assets/icons/kefu-icon.svg" height="15" alt />
                联系客服
            </span>
            <span
                class="bg-[#535660] text-white right-action-btn inline-block flex items-center justify-center gap-1">订阅/付款
                <img src="@/assets/icons/payment-icon.svg" height="15" alt /></span>
            <span
                class="bg-gradient-to-r from-[#2B8CFF] to-[#6B6F7C] text-[#FFFFFF] right-action-btn inline-block flex items-center justify-center gap-1">获取订单
                <img src="@/assets/icons/refresh-w-icon.svg" height="15" alt /></span>

        </div>
    </div>
</template>
<script setup>
import { DownOutlined } from '@ant-design/icons-vue';

</script>
<style lang="less" scoped>
.top-bar {
    width: 100%;
    height: 56px;
    background-color: #fff;
    border-bottom: 1px solid #eef2f8;
    padding: 0 40px;

    .top-bar-menu {
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        color: #3F4249;
    }
}

:deep(.ant-dropdown-link) {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;

    &:hover {
        color: #3F4249;
    }
}

.right-action-btn {
    padding: 6px 10px;
    border-radius: 4px;
    cursor: pointer;
}
</style>